<template>
  <section
    :class="['comp-popuplist-container', isMobile ? '' : 'desktop']"
    v-show="showList.length && !isIAP"
  >
    <van-dialog
      v-model="showPopupList"
      class="comp-popup-dialog"
      :show-cancel-button="false"
      :show-confirm-button="false"
      :close-on-click-overlay="false"
    >
      <div class="popup-swiper-body">
        <van-swipe
          :autoplay="2000"
          class="popup-swiper-container"
          @change="onChangeItem"
        >
          <van-swipe-item v-for="(item, index) in showList" :key="index">
            <van-image
              lazy-load
              :src="item.imgUrl"
              @click="goDetail(item)"
              alt="swiper-img"
            />
          </van-swipe-item>
        </van-swipe>
        <van-icon
          name="close"
          color="#fff6f699"
          size="32"
          class="close-comp-popup"
          @click="closePopup"
        />
      </div>
    </van-dialog>
  </section>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import { getPopup, getPopupById } from '@/api/popupList'
  import { jsontoString } from '@/utils/tool'
  import { storage } from '@/utils/storage'
  import { isXiaomiDeviceForPopup, isIosDevice } from '@/utils/utils'
  import { PQ, Message } from '@/utils/priorityQueue'
  import { pagePopupShow, pagePopupClick } from '@/pages/marketingFirebase.js'
  import { changeTitleBarMode } from '@/utils/native'
  import { fixSource } from '@/utils/request_helper.js'
  import { isMsaWebView } from '@/utils/msa'
  import { jumpToPage } from '@/utils/utils'

  const WAITING_TIME = 3000
  const popup_id = 'operate-popup'
  const POPUPLIST_NEW = 'popupListNEW'
  const OPERATE_POPUPLIST = 'operatePopupList'

  export default {
    name: 'popup-list',
    props: {
      pageType: {
        type: Number,
        default: 1,
      },
    },
    data() {
      return {
        show: false,
        popupList: [],
        popupListForBanner: [],
        showList: [],
        timer: null,
        showPopupList: false,
        sourceType: 1,
        exposedListId: [],
        timestamp: new Date().valueOf(),
        deviceType: 1,
      }
    },
    computed: {
      ...mapState([
        'region',
        'isMobile',
        'isApp',
        'userInfo',
        'isDesktop',
        'gameName',
        'isXiaomiDevice',
        'source',
        'members',
        'isIAP',
      ]),
      ...mapState('detail', ['operateLayer']),
    },
    watch: {
      // 监听点击的运营弹层的数据、展示运营弹层的数据
      operateLayer: {
        handler(newVal) {
          this.showPopuplistForBanner(newVal.popupId)
        },
        deep: true,
      },
      show(val) {
        if (val) {
          PQ.enqueue({
            id: popup_id,
            priority: 6,
          })
        }
      },
      showPopupList(val) {
        if (val) {
          // 弹框曝光埋点
          const id = this.popupList[0]?.id || ''
          if (!this.exposedListId.includes(id)) {
            pagePopupShow({
              page: this.gameName || 'home',
              list_id: id, // CMS配置编号
            })
            this.exposedListId.push(id)
          }
        }
      },
      userInfo(newState) {
        if (!newState) return
        if (!newState.loginTypeIsAuto) {
          this.getPopupList()
        }
      },
    },
    mounted() {
      // msa屏蔽云控弹窗
      if (isMsaWebView()) return
      this.getDeviceType()
      this.getPopupList()
    },
    methods: {
      ...mapMutations(['detail/setIsPierceLogoLayer']),

      callLogin() {
        const start = Date.now()
        this['detail/setIsPierceLogoLayer'](start)
      },
      onChangeItem(index) {
        const { id } = this.popupList[index]
        if (!this.exposedListId.includes(id)) {
          pagePopupShow({
            page: this.gameName || 'home',
            list_id: id, // CMS配置编号
          })
          this.exposedListId.push(id)
        }
      },
      //判断弹框列表中的活动是否超过间隔
      beforeSetPopupList(res) {
        //存储key
        if (!storage.get(OPERATE_POPUPLIST)) {
          storage.set(OPERATE_POPUPLIST, [
            {
              key: 'init',
              popupTime: this.timestamp,
            },
          ])
        }
        //json转数组
        const operatePopupList = storage.get(OPERATE_POPUPLIST)
        //过滤不需要的弹框
        const resFix = res.filter((item) => {
          let isPopup = false
          let isStorage = false
          const homeStr = `${POPUPLIST_NEW}_${item.id}_${item.country}`
          const gameStr = `${POPUPLIST_NEW}_${item.id}_${item.country}_${item.game}`
          const keyStr = this.pageType * 1 == 2 ? gameStr : homeStr
          operatePopupList.forEach((popitem) => {
            if (popitem.key === keyStr) {
              isStorage = true
              const interval = this.timestamp - popitem.popupTime
              if (interval - item.timeInterval * 3600000 > 0) {
                popitem.popupTime = this.timestamp
                isPopup = true
              }
            }
          })
          if (!isStorage) {
            operatePopupList.push({ key: keyStr, popupTime: this.timestamp })
            isPopup = true
          }
          return isPopup
        })
        storage.set(OPERATE_POPUPLIST, operatePopupList)
        //删除旧版本的旧key值
        for (let i = 0; i < localStorage.length; i++) {
          let key = localStorage.key(i)
          if (key.indexOf('popupListShow') > -1) storage.remove(key)
        }
        return resFix
      },
      getPopupList() {
        if (!process.client) return
        if (this.show) return
        if (!this.pageType) return
        // 当天仅展示一次
        /* if (!this.handleShow(type)) return */
        // source：根据地址栏是否包含source区分
        const { source = '' } = this.$route.query
        let params = {
          country: this.region,
          source: source,
          type: this.pageType,
          deviceType: this.deviceType,
        }
        this.gameName && (params.game = this.gameName)
        getPopup(params, false)
          .then((res) => {
            if (Array.isArray(res) && res.length) {
              //修正弹框列表
              let popupListFix = this.beforeSetPopupList(res)
              if (Array.isArray(popupListFix) && popupListFix.length) {
                this.popupList = popupListFix
                this.timer = setTimeout(() => {
                  this.showPopuplist()
                }, WAITING_TIME)
              } else {
                this.showList = this.popupList = []
              }
            } else {
              this.showList = this.popupList = []
            }
          })
          .catch(() => {
            this.showList = this.popupList = []
          })
      },
      showPopuplist() {
        this.showList = this.popupList
        this.show = true
      },
      showPopuplistForBanner(popupId = 0) {
        if (!popupId) return
        const { source = '' } = this.$route.query
        getPopupById({
          popupId,
          country: this.region,
          deviceType: this.deviceType,
          source,
        })
          .then((res) => {
            if (Array.isArray(res) && res.length) {
              this.showList = this.popupListForBanner = res
              this.show = true
            } else if (res instanceof Object && Object.keys(res).length) {
              this.showList = this.popupListForBanner = [res]
              this.show = true
            } else {
              this.showList = this.popupListForBanner = []
            }
          })
          .catch(() => {
            this.showList = this.popupListForBanner = []
          })
      },
      goDetail(item) {
        let source = (fixSource({ source: this.source }) || {}).source

        if (source === 'undefined' || source === '') {
          source = 'xm-MVP'
        }
        let query = { source }
        this.isPwa && Object.assign(query, { isPwa: true })
        pagePopupClick({
          page: this.gameName || 'home',
          list_id: item.id || '',
        })
        // 根据跳转类型判断
        switch (item.buttonOperation * 1) {
          case 1:
            // 跳转链接
            if (item.buttonJumpUrl) {
              if (this.isApp && this.pageType === 2) {
                changeTitleBarMode(0)
              }
              jumpToPage(
                `${item.buttonJumpUrl}${
                  item.buttonJumpUrl.indexOf('?') > -1 ? '&' : '?'
                }${jsontoString(query)}`
              )
            }
            break
          case 2:
            // 登录弹窗
            this.closePopup()
            if (this.pageType === 2) {
              this.callLogin()
            } else {
              this.$emit('login', { type: 'popuplist' })
            }
            break
          default:
            break
        }
      },
      closePopup() {
        this.show = false
        PQ.close(popup_id)
        PQ.dequeue(popup_id)
        this.showPopupList = false
      },
      getDeviceType() {
        if (!!this.isXiaomiDevice || isXiaomiDeviceForPopup()) {
          this.deviceType = 1
        } else if (isIosDevice()) {
          this.deviceType = 2
        } else {
          this.deviceType = 3
        }
      },
    },
    created() {
      if (!process.client) return
      Message.receive((res) => {
        const { id } = res || {}
        if (id === popup_id) {
          this.showPopupList = true
          PQ.open(popup_id)
        }
      })
    },
    beforeDestroy() {
      this.timer && clearTimeout(this.timer) && (this.timer = null)
    },
  }
</script>

<style lang="scss" src="./index.scss"></style>
<style lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
